export default function removeScroll(rect, scroll) {
    return {
        top: rect.top - scroll.y,
        left: rect.left - scroll.x,
        height: rect.height,
        width: rect.width
    };
}



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-popup-common/dist/es/remove-scroll.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/remove-scroll.js
// module chunks = vendor